import React from 'react';
import {makeStyles} from "@material-ui/styles";
import clsx from "clsx";


const useStyles = makeStyles(
    (theme) => {
        return {
            active: {
                color: theme.palette.primary.main
            },
            completed: {
                color: theme.palette.success.main
            },
            item: {
                fontSize: 49
            }
        }
    }
);

export default function NewFicheFormStepIcon(props){

    const classes = useStyles();
    const { active, completed } = props;

    const icons = {
        1: <span className={clsx([classes.item,'la la-clipboard-list'])}></span>,
        2: <span className={clsx([classes.item,'la la-search-location'])}></span>,
        3: <span className={clsx([classes.item,'la la-calendar'])}></span>,
        4: <span className={clsx([classes.item,'la la-address-card'])}></span>,
    };


    return (
        <div>
            <div
                className={clsx({[ classes.active]: (active),[ classes.completed]: (completed)})}
            >
                {icons[String(props.icon)]}
            </div>
        </div>
    )
}